// Copyright (c) 2022 Siemens

/**
 * @module js/DesCatalogPartConfigService
 */
import _ from 'lodash';
import appCtxSvc from 'js/appCtxService';
import eventBus from 'js/eventBus';
import viewModelObject from 'js/viewModelObjectService';
import CatalogHttpService from 'js/catalogHttpService';
import * as utils from '../js/CatalogUtils';

const LOV_CHANGE_EVENT_NAME = 'des-feature-group.selectionChange';

/**
 * render function for AwLovEdit
 * @param {*} param0 context for render function interpolation
 * @returns {JSX.Element} react component
 */

/**
 * Get Filter data
 *
 * @param {Object} results results
 * @return {Object} the filter data
 */

let accsessionid;
let provider;
let catalogspaceId;
let configMapping = null;
let allViewersInfo;

export const nextViewer = function (vmo) {
    const {
        data,
        dispatch
    } = vmo;

    let index = data.viewerIndex;
    if (data.viewerIndex === data.allViewersData.length - 1) {
        index = 0;
    } else {
        index++;
    }

    data.viewerIndex = index;
    const allViewersData = data.allViewersData;

    allViewersData.forEach(function (viewer, currIndex) {
        if (currIndex === data.viewerIndex) {
            data.viewerSRC = viewer.propInternalValue;
            data.viewerName.dbValue = viewer.displayView;
            data.ViewerTextLink.displayName = viewer.propDisplayValue;
            data.ViewerTextLink.propertyDisplayName = viewer.propDisplayValue;
            data.ViewerTextLink.uiValue = viewer.propDisplayValue;
        }
    });
    dispatch({
        path: 'data',
        value: {
            ...data
        }
    });
}

export const previousViewer = function (vmo) {
    const {
        data,
        dispatch
    } = vmo;

    let index = data.viewerIndex;
    if (data.viewerIndex === 0) {
        index = data.allViewersData.length - 1;
    } else {
        index--;
    }

    data.viewerIndex = index;
    const allViewersData = data.allViewersData;

    allViewersData.forEach(function (viewer, currIndex) {
        if (currIndex === data.viewerIndex) {
            data.viewerSRC = viewer.propInternalValue;
            data.viewerName.dbValue = viewer.displayView;
            data.ViewerTextLink.displayName = viewer.propDisplayValue;
            data.ViewerTextLink.propertyDisplayName = viewer.propDisplayValue;
            data.ViewerTextLink.uiValue = viewer.propDisplayValue;
        }
    });

    dispatch({
        path: 'data',
        value: {
            ...data
        },
    });
}

export const updateAllViewersSRC = (vmo, currAllViewersInfo) => {
    const {
        data,
        dispatch
    } = vmo;
    data.allViewersData = currAllViewersInfo;
    data.viewerSRC = currAllViewersInfo[0].propInternalValue;
    data.viewerName.dbValue = currAllViewersInfo[0].displayView;
    data.ViewerTextLink.displayName = currAllViewersInfo[0].propDisplayValue;
    data.ViewerTextLink.propertyDisplayName = currAllViewersInfo[0].propDisplayValue;
    data.ViewerTextLink.uiValue = currAllViewersInfo[0].propDisplayValue;

    dispatch({
        path: 'data',
        value: {
            ...data
        }
    });
}

export const handleSelectionChangeForViewers = (selectionData, vmo) => {
    const {
        data,
        dispatch
    } = vmo;

    data.displayView = selectionData.selected[0].propDisplayValue;
    data.viewerSRC = selectionData.selected[0].propInternalValue;
    data.viewerName.dbValue = selectionData.selected[0].displayView;
    data.ViewerTextLink.propertyDisplayName = selectionData.selected[0].propDisplayValue;

    const viewerInfo = data.allViewersData;
    const index = viewerInfo.map(viewer => viewer.propDisplayValue).indexOf(selectionData.selected[0].propDisplayValue);
    data.viewerIndex = index;

    dispatch({
        path: 'data',
        value: {
            ...data
        }
    });
};

export const processResults = function (response, startIndex, pageSize, vmo) {
    const {
        part,
        propertiesOfPart
    } = response;

    const featureGroupId = _.get(part, 'product.featureGroupId', _.get(part, 'featureGroupId'));
    appCtxSvc.registerCtx('featureGroupId', featureGroupId);

    for (const element of propertiesOfPart) {
        viewModelObject.updateVMOProperties(element);
    }

    return propertiesOfPart;
};

export const splmTableStartEditConfig = (data) => {
    return data;
};

export const registerSelectedObject = (selectedObjects, vmo) => {
    const {
        data,
        dispatch
    } = vmo;

    data.viewerInfo.propInternalValue =  _.get(selectedObjects, '0.typeIconURL');
	    dispatch({
        path: 'data',
        value: {
            ...data
        }
    });
    return new Promise(resolve => {
        setTimeout(() => {
            const feature = selectedObjects;
            appCtxSvc.registerCtx('feature', feature);

            const previousLOVvalue = _.get(selectedObjects, '0.props.value.displayValue')

            resolve({
                previousLOVvalue
            });
        }, 500);
    });
};

export const getFeatureGroupValuesInput = (inputFeatureData, vmo) => {
    return new Promise(resolve => {
        setTimeout(() => {
            const inputValuesOfFeatureGroup = {
                featureName: inputFeatureData[0].featureName,
                isLOVSelected: false,
                propDisplayValue: inputFeatureData[0].propDisplayValue
            }

            const {
                data,
                dispatch
            } = vmo;
            data.checkForResetSelection = false;
            dispatch({
                path: 'data',
                value: {
                    ...data
                }
            });

            resolve({
                inputValuesOfFeatureGroup
            });
        }, 500);
    });
};

export const updateCancelEditActionFlag = (vmo) => {
    const {
        data,
        dispatch
    } = vmo;
    data.checkForResetSelection = true;
    data.refreshTableLov = false;
    dispatch({
        path: 'data',
        value: {
            ...data
        }
    });
    configMapping = null;
    appCtxSvc.registerCtx('loadLovUsingAPI', false);
};

export const executePostResetConfig = (vmo) => {
    appCtxSvc.updateCtx('isConfigurePartValues', false);
    appCtxSvc.updateCtx('enableApplyConfig', false);
}

export const getInputsForFeatureGroup = function (vmo) {

    const {
        data,
        dispatch
    } = vmo;
    data.accsessionid = accsessionid;
    data.provider = provider;
    data.catalogspaceId = catalogspaceId;
    dispatch({
        path: 'data',
        value: {
            ...data
        }
    });
}

export const SetProperties = function (vmo, props, part, invokedFrom) {
    const partPropsUpdated = false;
    if (invokedFrom === 'part-summary') {
        const {
            data,
            dispatch
        } = vmo;
        let name = _.get(part, 'product.name');
        let catalog = _.get(part, 'product.catalogName');
        let partNumber = _.get(part, 'product.description');

        const viewModelProps = ['dbValue', 'dispValue', 'value', 'uiValue'];
        const updateDataModel = (propName, propVal) => {
            viewModelProps.forEach((element) => {
                data[propName][element] = propVal;
            });
        }

        if (data.catalog) {
            if (utils.isNullOrEmpty(catalog)) {
                catalog = appCtxSvc.getCtx('catalogName');
            }
            updateDataModel('catalog', catalog);
        }

        if (data.name) {
            if (utils.isNullOrEmpty(name)) {
                const partName = appCtxSvc.getCtx('partName');
                if (utils.isNullOrEmpty(partName)) {
                    name = catalog;
                } else{
                    name = partName;
                }
            }
            updateDataModel('name', name);
        }

        if (data.partNo) {
            if (utils.isNullOrEmpty(partNumber)) {
                partNumber = appCtxSvc.getCtx('partNo');
            }
            updateDataModel('partNo', partNumber);
        }

        // Get default preview url
        const defaultPreviewUrl = _.get(data, 'output.previewUrl');
        if (defaultPreviewUrl) {
            data.defaultPreview.dbValue = defaultPreviewUrl;
        }
        dispatch({
            path: 'data',
            value: {
                ...data
            }
        });
    }
    return {
        partPropsUpdated: partPropsUpdated
    };
}

const invalidLovSelectionMap = {};
const processVisibleTrueLov = (props, featureGroup, uId) => {
    const featureGroups = _.get(props, 'vmo.featureGroups', []).filter(ele => _.get(ele, 'visible') === true);
    if (featureGroups && featureGroups.length === 1) {
        const nameMatch = featureGroups[0]['featureName'] === featureGroup['featureName'];
        const valMatch = featureGroups[0]['propInternalValue'] === featureGroup['propInternalValue'];
        if (nameMatch && valMatch) {
            console.log('skip the lov change event')
        } else {
            _.set(featureGroup, 'uid', uId);
            eventBus.publish(LOV_CHANGE_EVENT_NAME, featureGroup);
            appCtxSvc.registerCtx('enableApplyConfig', true);
        }
    } else {
        _.set(featureGroup, 'uid', uId);
        eventBus.publish(LOV_CHANGE_EVENT_NAME, featureGroup);
        appCtxSvc.registerCtx('enableApplyConfig', true);
    }
    _.set(invalidLovSelectionMap, uId, {
        status: 'VALID_LOV',
        featureGroup: featureGroup
    });
}

const processVisibleFalseLov = (featureGroup, uId) => {
    const isPrimary = _.get(featureGroup, 'isPrimary');
    if (isPrimary) {
        _.set(featureGroup, 'uid', uId);
        eventBus.publish(LOV_CHANGE_EVENT_NAME, featureGroup);
    } else {
        // Update LOV selection map
        _.set(invalidLovSelectionMap, uId, {
            status: 'INVALID_LOV',
            featureGroup: featureGroup
        });
        eventBus.publish('des-feature-group.invalidSelection', featureGroup);
    }
}

export const logSelectedObject = (selectedLovs, props) => {
    const featureGroup = _.get(selectedLovs, 0);
    const uId = _.get(props, 'vmo.uid');
    const isSelected = _.get(featureGroup, 'selected');
    const isVisible = _.get(featureGroup, 'visible');
    if (true === isSelected && true === isVisible) {
        // One more validation
        processVisibleTrueLov(props, featureGroup, uId);
    } else if (true === isSelected && false === isVisible) {
        processVisibleFalseLov(featureGroup, uId);
    }
}

export const validateSelectedLovs = () => {
    const invalidFeatureGroup = {
        featureGroup: null,
        isInvalid: false
    }
    for (const property in invalidLovSelectionMap) {
        console.log(`${property}: ${invalidLovSelectionMap[property]}`);
        if (_.get(invalidLovSelectionMap, `${property}.status`) === 'INVALID_LOV') {
            invalidFeatureGroup.featureGroup = _.get(invalidLovSelectionMap, `${property}.featureGroup`);
            invalidFeatureGroup.isInvalid = true;
        }
    }
    appCtxSvc.registerCtx('invalidFeatureGroupSelection', invalidFeatureGroup);
}

export const updatePartPropertiesConfig = (properties) => {
    if (configMapping === null) {
        configMapping = {};
    }
    for (let i = 0; i < properties.length; i++) {
        const uId = _.get(properties, `${i}.uid`);
        const value = _.get(properties, `${i}.props.value.value`);
        configMapping[uId] = {
            initialValue: value
        }
    }
}

export const updateConfigLovChnagedFlag = (vmo, eventData) => {
    const {
        data,
        dispatch
    } = vmo;
    const uId = _.get(eventData, 'uid');
    // get mapper config
    const mapperObj = _.get(configMapping, uId);

    let refreshOnly = false;
    let checkSelectedAndExistingLov = false;
    // Validate mapping
    if (!_.isNil(mapperObj)) {
        // get value
        const currentVal = _.get(mapperObj, 'initialValue');
        if (currentVal === eventData['propInternalValue']) {
            console.log('Existing and selected lovs are same. Hence skipping the table refresh.');
            checkSelectedAndExistingLov = true;
        } else {
            console.log('Initiating table refresh.');
            refreshOnly = true;
        }

        if (!checkSelectedAndExistingLov) {
            if (!refreshOnly) {
                refreshOnly = appCtxSvc.getCtx('loadLovUsingAPI');
            }
            // validate event uid
            data.refreshTableLov = refreshOnly;
            data.getFeatureGroupInput = {
                featureGroupId: eventData['featureGroupId'],
                values: [{
                    name: eventData['featureName'],
                    value: eventData['propInternalValue']
                }]
            };
            dispatch({
                path: 'data',
                value: {
                    ...data
                }
            });
            if (refreshOnly) {
                eventBus.publish('lovChanged.refreshTable');
            }
        }
    }
}

export const loadPartDetails = async (vmo, props) => {
    const {
        data
    } = vmo;
    let output = null;
    const listProductsForFeatureGroupQuery = `query ListProductsForFeatureGroup($listProductsForFeatureGroupInput: ListProductsForFeatureGroupInput) {
                listProductsForFeatureGroup(listProductsForFeatureGroupInput: $listProductsForFeatureGroupInput)}`;
    const input = {
        "additionalProperties": {},
        "appBaseUrl": "assets",
        "query": listProductsForFeatureGroupQuery,
        "variables": {
            "listProductsForFeatureGroupInput": {
                "catalogspaceId": props.catalogspaceid,
                "featureGroupId": props.featureGroupId,
                "provider": props.provider,
                "partId": props.partid,
                "locale":props.locale
            }
        }
    };
    const res = await CatalogHttpService.createHttpRequest(input, props.accsessionid);
    output = {
            ..._.get(res, 'data.data.listProductsForFeatureGroup')
    };
    data.propOfPart = _.get(res, 'data.data.listProductsForFeatureGroup.propOfPart');
    const product = _.get(res, 'data.data.listProductsForFeatureGroup.part.product');
    appCtxSvc.registerCtx('partName', product.name);
    appCtxSvc.registerCtx('catalogName', product.catalogName);
    appCtxSvc.registerCtx('partNo', product.description);
    return Promise.resolve(output);
}

export const updateVmoByName = (vmo, name, value) => {
    const {
        data,
        dispatch
    } = vmo;
    data[name] = value;
    dispatch({
        path: `data.${name}`,
        value: value
    });
    appCtxSvc.registerCtx('loadLovUsingAPI', false);
    return {
        refreshTableLov: false
    }
}

export const updateCtxByName = (name, value, values) => {
    if (values && Array.isArray(values) && values.length) {
        values.forEach((item) => {
            appCtxSvc.registerCtx(item['name'], item['value']);
        });
    } else {
        appCtxSvc.registerCtx(name, value);
    }
}

export const onAfterApplyConfig = (vmo) => {
    const {
        dispatch
    } = vmo;
    appCtxSvc.updateCtx('enableApplyConfig', false);
    dispatch({
        path: 'data.listProductForFeatureGroup',
        value: false
    });
}

/**
 * Get the matrix columns
 */
export const loadMatrixColumns = async function( vmo, dataProvider) {
    const {
        data
    } = vmo;
    const enableColumnMenu = false;
    let  colProperties = [];
    colProperties = data.propertiesOfPart;
    const columns = [];

    for( let i = 0; i < colProperties.length; i++ ) {
        // create a column per property in this case
        const prop = colProperties[ i ];
        let propDisplayValue = '';
        const propName = prop.props.name.dbValue;
        const uom = data.output.data.product.properties[i].uom;
        if (utils.isNullOrEmpty(uom)) {
            propDisplayValue = prop.props.name.displayValue;
          } else {
            propDisplayValue = `${prop.props.name.displayValue} [${uom}]`;
        }
        const currColumn = createColumnInfo( propName, propDisplayValue, 200, enableColumnMenu );
        currColumn.type = 'STRING';
        columns.push( currColumn );
    }
    dataProvider.columnConfig = {
        columns: columns
    };
    return columns;
};

const createColumnInfo = function( name, displayName, width, enableColumnMenu ) {
    return {
        name: name,
        displayName: displayName,
        width: width,
        enableColumnMoving: false,
        enableColumnMenu: enableColumnMenu,
        isFilteringEnabled: false,
        enableSorting: false,
        enableColumnResizing: true
    };
};

export const getPartDetails  = async (vmo, props, selectedObjects) => {
    const {
        data, dispatch
    } = vmo;
    const modelPath = _.get(selectedObjects, '0.modelPath');
    const input = {
        "additionalProperties": {},
        "appBaseUrl": "assets",
        "query": "query GetPartDetails($getPartDetailsInput: GetPartDetailsInput) { getPartDetails(getPartDetailsInput: $getPartDetailsInput) }",
        "variables": {
            "getPartDetailsInput": {
                "attachments": 'all',
                "catalogspaceId": props.catalogspaceid,
                "partId": props.partid,
                "provider": props.provider,
                "locale": props.locale,
                "partConfigurationInput": {
                    "featureGroupInputs": data.inputValuesOfFeatureGroup,
                    "refreshTableLovInput": data.getFeatureGroupInput,
                    "checkForResetSelection": data.checkForResetSelection,
                    "isRefreshTableLov": data.refreshTableLov
                }
            }
        }
    }
    if(modelPath !== undefined || modelPath!== null) {
        input.variables.getPartDetailsInput.modelPath = modelPath;
    }
    if(selectedObjects !== undefined || selectedObjects!== null) {
        input.variables.getPartDetailsInput.partId = _.get(selectedObjects, '0.selectedPartId', props.partid);
    }
    try {
        const res = await CatalogHttpService.createHttpRequest(input, props.accsessionid);
        const featureGroupIdOfPart = _.get(res, 'data.data.getPartDetails.part.product.featureGroupId');
        const part = _.get(res, 'data.data.getPartDetails.part');
        data.featureGroupIdOfPart = featureGroupIdOfPart;
        allViewersInfo =  _.get(res, 'data.data.getPartDetails.allViewersInfo');

        data.allViewersInfo = allViewersInfo;
        dispatch({
            path: 'data',
            value: data
        });
        eventBus.publish('getProperties.success', part);
        eventBus.publish('getPartDetails.success', allViewersInfo);
    } catch (err) {
        console.log('error inside getproduct call', err);
        throw err;
    }
};

export const setProductSelection = (autoSelectFirst, data) => {
    if (autoSelectFirst === 'true') {
        const loadedVMCollection = data.dataProviders.partSummaryTableRowProvider.getViewModelCollection();
        const vmToSelect = loadedVMCollection.getViewModelObject(0);
        if (vmToSelect) {
            data.dataProviders.partSummaryTableRowProvider.selectionModel.setSelection(vmToSelect);
        }
    }

}

export const registerCarouselVisibility = (vmo, props) => {
    const { data, dispatch } = vmo;
    if(props.disablecarousel === false || props.disablecarousel === 'false' || props.disablecarousel === undefined || props.disablecarousel === ''){
        appCtxSvc.registerCtx('carouselVisibiliy', true);
    } else{
        appCtxSvc.registerCtx('carouselVisibiliy', false);
    }
    dispatch({ path: 'data', value: { ...data } });
};
